import { axiosInstance } from "./";

const login = async (payload) =>
  await axiosInstance.post(
    "/api/Authenticate/LoginEmployee",
    payload
  );

const logout = async (payload) =>
  await axiosInstance.delete("/sessions", { data: payload });

const changePassword = async (payload) =>
  await axiosInstance.post("/admins/change_password", payload);

const resetPassword = async (payload) =>
  await axiosInstance.post(
    "/api/Authenticate/EmployeeResetPassword",
    payload
  );

const isUserForcedLogout = async (params) =>
  await axiosInstance.get("/api/Employee/GetForceLogout", {
    params
  });

const modifyIsForceLogout = async (params) =>
  await axiosInstance.get("/api/Employee/ForceLogout", {
    params
  });

export {
  login,
  logout,
  changePassword,
  resetPassword,
  isUserForcedLogout,
  modifyIsForceLogout
};
